import { useEffect, useRef } from "react";
import type { ProductType } from "@/types/product";
import { gaItemFromProduct, gaViewItemList } from "@/utils/gaEvent";

interface TrackedListState {
  listId: string;
  productIds: Array<string | number>;
}

export const useGAProductList = (
  products: ProductType[],
  listId: string,
  listName: string,
) => {
  const trackedRef = useRef<TrackedListState>({
    listId: "",
    productIds: [],
  });

  useEffect(() => {
    if (!products.length) return;

    const productIds = products.map((product) => product.productID);
    const previous = trackedRef.current;
    const hasSamePrefix =
      previous.listId === listId &&
      previous.productIds.every(
        (productId, index) => productIds[index] === productId,
      );
    const startIndex = hasSamePrefix ? previous.productIds.length : 0;
    const newProducts = products.slice(startIndex);

    if (newProducts.length) {
      gaViewItemList({
        item_list_id: listId,
        item_list_name: listName,
        items: newProducts.map((product, index) =>
          gaItemFromProduct(product, {
            index: startIndex + index,
            itemListId: listId,
            itemListName: listName,
          }),
        ),
      });
    }

    trackedRef.current = { listId, productIds };
  }, [listId, listName, products]);
};
